import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    IconButton,
} from '@material-ui/core';
import { format } from 'date-fns';
import withStyles from '@material-ui/core/styles/withStyles';
import { makeStyles } from '@material-ui/core/styles';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { useTranslation } from 'react-i18next';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    tableTitle: {
        display: 'inline-block',
        position: 'relative',
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        fontSize: '1rem',
        fontWeight: 600,
    },
    subtitle: {
        display: 'block',
        fontSize: '0.8rem',
    },
    table: {
        marginBottom: theme.spacing(3),
        '&:last-child': {
            marginBottom: 0,
        },
    },
}));

const TableTemplate = ({
    title,
    subtitle,
    columnTitles,
    rows,
    handleCellClick,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const formattedRows = rows.length
        ? rows
        : new Array(columnTitles.length).fill('-');
    function tableDateFormat(inputDate){
        var outputDate = "";
        try{
            outputDate = format(new Date(inputDate), 'MM/dd/yyyy');
        } catch {
            console.log("DateFormatError : {date}".replace("{date}", inputDate));
            var tempDate = inputDate;
            if(tempDate.includes("+")){
                //tempDate = tempDate.substring(0, tempDate.indexOf('+')).replace(" ","T")+"Z";
                tempDate = tempDate.substring(0, tempDate.indexOf('+')).replace(" ","T");
                //tempDate = tempDate.substring(0, tempDate.indexOf('+'));
            }
            //console.log("tempDate: {date}".replace("{date}",tempDate));
            outputDate = format(new Date(tempDate), 'MM/dd/yyyy');
        }
        return outputDate;
    }
    
    return (
        <>
            <Typography className={classes.tableTitle} variant="h6">
                {t(title)}
            </Typography>
            {subtitle && (
                <Typography className={classes.subtitle} variant="subtitle1">
                    {t(subtitle)}
                </Typography>
            )}
            <TableContainer className={classes.table} component={Paper}>
                <Table size="small" aria-label="user permissions table">
                    <TableHead>
                        <TableRow>
                            {!!Object.values(columnTitles).length &&
                                Object.values(columnTitles).map((el) => (
                                    <StyledTableCell key={el.slice(0, 2)}>
                                        {t(el)}
                                    </StyledTableCell>
                                ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {formattedRows.map((row) => {
                            if (row === '-') {
                                return (
                                    <StyledTableRow>
                                        {Object.keys(columnTitles).map((el, index) => (
                                            <TableCell key={index}>{row}</TableCell>
                                        ))}
                                    </StyledTableRow>
                                );
                            }

                            return (
                                <StyledTableRow key={row.id}>
                                    {Object.keys(columnTitles).map(
                                        (el, index) => {
                                            if (
                                                el === 'id' &&
                                                typeof handleCellClick ===
                                                'function'
                                            ) {
                                                return (
                                                    <TableCell key={index}>
                                                        <IconButton
                                                            data-id={row[el]}
                                                            onClick={
                                                                handleCellClick
                                                            }>
                                                            <PictureAsPdfIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                );
                                            }

                                            if (
                                                el === 'next_invoice_date' ||
                                                el === 'closed_at' ||
                                                el === 'due_at'
                                            ) {
                                                return (
                                                    <TableCell key={index}>
                                                        {row[el] === null ? "" :
                                                            tableDateFormat(row[el])}
                                                    </TableCell>
                                                );
                                            }

                                            return (
                                                <TableCell key={index}>
                                                    {t(row[el])}
                                                </TableCell>
                                            );
                                        }
                                    )}
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default TableTemplate;